export const YEAR_IN_SECONDS = '31536000';
export const DAY_IN_SECONDS = '86400';
